import React from "react";
import Hero from "../sections/Hero";
import Spotlight from "../sections/Spotlight";
import Best from "../sections/Best";
import SignUp from "../sections/SignUp";
import Reviews from "../sections/Reviews";

function Home() {
  return (
    <>
      <Hero />
      <div className="bg-white flex flex-col items-center mb-[30vh] gap-8 relative z-50 min-h-screen mt-[100vh]">
        <Spotlight />
        <Best />
        <Reviews />
        <SignUp />
      </div>
    </>
  );
}

export default Home;
